import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import BaseFooter from '&/components/BaseFooter';
import BaseHeader from '&/components/BaseHeader';
import SignInDlg from '&/components/Dialogs/SignInDlg';
import ApplyTrialDlg from '&/components/Dialogs/ApplyTrialDlg';
import OrganizationSelectDlg from '&/components/Dialogs/OrganizationSelectDlg';
import Routers, { EXCLUSIVE_ROUTES } from './routerMap';
import TDK from '&/components/TDK';
import { inject, observer } from 'mobx-react';
import ResetPage from '&/components/ResetPage';
import { redirectList } from '@/constants';

function Container(props) {
    const { appStore } = props;
    const routerRender = props => {
        const { search, pathname } = props.location;
        const params = new URLSearchParams(search);
        //  H5打开
        const isWcp = params.get('type') === 'wcp';
        const isFreeUse = params.get('from') === 'freeUse';
        const combination = params.get('c');

        if (
            (redirectList.includes(pathname) ||
                ['/user-center'].includes(props.match.path)) &&
            !appStore.isLogIn &&
            !isWcp
        ) {
            isFreeUse && appStore.setIsFreeUseLogin(true);
            if (!combination) {
                props.history.push(
                    '/login/signin?redirect=' +
                        encodeURIComponent(pathname + search)
                );
            }
            return false;
        } else {
            return true;
        }
    };

    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <ResetPage />
            <Switch>
                {EXCLUSIVE_ROUTES.map((e, idx) => (
                    <Route
                        key={idx}
                        path={e.path}
                        render={props => {
                            const RES = (
                                <>
                                    <TDK location={props.location}></TDK>
                                    <e.component {...props} />
                                </>
                            );
                            if (
                                !e.needIntercept ||
                                (e.needIntercept && routerRender(props))
                            ) {
                                return RES;
                            }
                        }}
                    />
                ))}

                <React.Fragment>
                    <BaseHeader />
                    <SignInDlg />
                    <ApplyTrialDlg />
                    <OrganizationSelectDlg />
                    <div className="hd-layout">
                        <Switch>
                            {Routers.map((item, index) => (
                                <Route
                                    key={index}
                                    path={item.path}
                                    render={props => {
                                        if (routerRender(props)) {
                                            return (
                                                <>
                                                    <TDK
                                                        location={
                                                            props.location
                                                        }></TDK>

                                                    <item.component
                                                        {...props}
                                                    />
                                                </>
                                            );
                                        }
                                    }}
                                />
                            ))}
                            <Redirect to="/home" />
                        </Switch>
                    </div>
                    <BaseFooter />
                </React.Fragment>
            </Switch>
        </BrowserRouter>
    );
}
export default inject('appStore')(observer(Container));
